import { useTheme } from 'emotion-theming';
import { ITheme } from '@commandbar/internal/client/theme';

export const useCommandBarTheme = (): ITheme => {
  return useTheme<{ theme: ITheme }>().theme;
};
